import { cn } from '@/lib/utils';
import { HeadlineType } from '@/lib/types';

export const HEADLINE_TYPE_LABEL: Record<HeadlineType, string> = {
  brand: 'Brand',
  benefit: 'Benefit',
  cta: 'CTA',
  feature: 'Feature',
  usp: 'USP',
  social_proof: 'Proof',
  keyword: 'Keyword',
};

// Brand Status-Pill colors (Tailwind -100/-800 for AA contrast). Light-only app,
// so no `dark:` variants. See CLAUDE-DESIGN-SYSTEM.md → Status Pills & Badges.
export const HEADLINE_TYPE_COLOR: Record<HeadlineType, string> = {
  brand: 'bg-purple-100 text-purple-800',
  benefit: 'bg-green-100 text-green-800',
  cta: 'bg-blue-100 text-blue-800',
  feature: 'bg-indigo-100 text-indigo-800',
  usp: 'bg-pink-100 text-pink-800',
  social_proof: 'bg-teal-100 text-teal-800',
  keyword: 'bg-gray-100 text-gray-800',
};

// Semantic sort order for the Type column (keyword first → cta last).
export const HEADLINE_TYPE_SORT_ORDER: Record<HeadlineType, number> = {
  brand: 0,
  keyword: 1,
  feature: 2,
  usp: 3,
  benefit: 4,
  social_proof: 5,
  cta: 6,
};

// Untyped headlines sort last. Used by the Type column's sortingFn.
export function headlineTypeRank(type: HeadlineType | null | undefined): number {
  if (!type) return Number.MAX_SAFE_INTEGER;
  return HEADLINE_TYPE_SORT_ORDER[type];
}

interface HeadlineTypeTagProps {
  type: HeadlineType;
  className?: string;
}

export function HeadlineTypeTag({ type, className }: HeadlineTypeTagProps) {
  const label = HEADLINE_TYPE_LABEL[type];
  return (
    <span
      title={`Type: ${label}`}
      className={cn(
        'inline-flex items-center rounded-full px-3.5 py-0.5 text-xs font-medium',
        HEADLINE_TYPE_COLOR[type],
        className,
      )}
    >
      {label}
    </span>
  );
}
